import React from 'react';
import PropTypes from 'prop-types';
import { base } from '@feast-it/pesto';
import { useRouter } from 'next/router';

import Meta from '../../components/Meta';
import {
  Client,
  formatMetadata,
  hasBorderlessHeader,
  hasTransparentHeader,
} from '../../modules/prismic/prismic';
import renderPrismicSections from '../../containers/prismic';
import Layout from '../../containers/layout';
import LayoutSkeleton from '../../containers/layout/LayoutSkeleton';
import { useBreakpoint } from '../../hooks/media';
import paths from '../../constants/paths';
import { useDynamicPageContent } from '../../hooks/useDynamicPageContent';

const ChristmasLanding = ({ id, data, metadata, keyword, preview }) => {
  const { isFallback } = useRouter();
  const theme = keyword?.contains('wedding') ? 'wedding' : 'base';
  const isDesktop = useBreakpoint(base.breakpoints.m);
  const { query } = useRouter();
  const { loading, dynamicContent: christmasContent } = useDynamicPageContent(
    id,
    query?.search_term,
    data
  );

  if (isFallback || loading) {
    return <LayoutSkeleton />;
  }

  return (
    <Layout
      theme={theme}
      headerCTA={christmasContent.header_cta_link.url}
      headerType={christmasContent.header_type}
      borderlessHeader={hasBorderlessHeader(christmasContent.body)}
      transparentHeader={hasTransparentHeader(christmasContent.body, isDesktop)}
      prismicPreview={preview}
    >
      <Meta {...metadata} path={paths.CHRISTMAS(id)} />
      {renderPrismicSections(christmasContent.body, keyword)}
    </Layout>
  );
};

export const getServerSideProps = async ({
  req,
  params: { id },
  preview = false,
  previewData = {},
}) => {
  const res = await Client(req).getByUID(
    'dynamic_landing_new',
    `christmas.${id}`,
    previewData?.ref ? { ref: previewData?.ref } : {}
  );

  if (res?.data) {
    const { data } = res;
    const metadata = await formatMetadata(data);

    return {
      props: { id, data, metadata, preview },
    };
  } else {
    return {
      notFound: true,
    };
  }
};

ChristmasLanding.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  metadata: PropTypes.object,
  keyword: PropTypes.string,
  preview: PropTypes.bool,
};

export default ChristmasLanding;
